module.exports = {"id":"176348","name":"Yeom Ki Hun","rating":"73","photo":"./data/images/photos/1/176348.png","club":{"name":"Suwon Bluewings","logo":"./data/images/clubs/SuwonBluewings.png"},"positions":["BU","MG"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/YeomKiHun0.json
// module id = 4403
// module chunks = 0